import { BaseConfig } from '../ServiceConfig';

export interface UserCornerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.UserCornerServiceConfigData';
  baseUrl: string;
  merchantWebUrl: string;
  voucherWebUrl: string;
}

export const UserCornerConfigurationFields: (keyof UserCornerConfiguration)[] = [
  'baseUrl',
  'merchantWebUrl',
  'voucherWebUrl',
];

export const BlankUserCornerConfiguration: UserCornerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.UserCornerServiceConfigData',
} as UserCornerConfiguration;
